import { useEffect, useRef } from "react";

export function youtubeId(input = "") {
  const s = String(input).trim();
  const m = s.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
  if (m) return m[1];
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  return "";
}

function ScriptBlock({ code }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "text/javascript";
    el.text = code;
    document.body.appendChild(el);
    return () => { try { document.body.removeChild(el); } catch (e) { /* noop */ } };
  }, [code]);
  return <span ref={ref} />;
}

export default function CustomBlocks({ zone, blocks = [] }) {
  const items = blocks.filter((b) => b.zone === zone && b.enabled !== false && b.content);
  if (items.length === 0) return null;
  return (
    <div data-testid={`custom-zone-${zone}`}>
      {items.map((b, i) => {
        if (b.type === "youtube") {
          const id = youtubeId(b.content);
          if (!id) return null;
          return (
            <section key={b.id || i} className="bg-black border-b border-white/10">
              <div className="max-w-5xl mx-auto px-5 py-14">
                <div className="relative w-full border border-nv/30" style={{ paddingTop: "56.25%" }}>
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${id}`}
                    title="Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </section>
          );
        }
        if (b.type === "script") {
          return <ScriptBlock key={b.id || i} code={b.content} />;
        }
        // html
        return (
          <div key={b.id || i} className="custom-html-block" dangerouslySetInnerHTML={{ __html: b.content }} />
        );
      })}
    </div>
  );
}
